import HeadWrapper from './HeadWrapper';

export default HeadWrapper;
